import { DOCAIApi } from "@/services/DocAIService";
import HttpClient from "@/services/HttpClient";
import type { RequestOptions } from "@/services/types";
import { FolderService } from "@/services/FolderService";

export interface FileResponse {
  _id: string;
  name_file: string;
  path_file: string;
  file_id_project: string;
  irai_id: string;
  type_extract: string;
  guid_file: string;
}

export interface GraphResponse {
  _id: string;
  irai_id: string;
  file_id: string;
  drawing_name: string;
  drawing_number: string;
  page: number;
  type_extract: string;
  title_page: {
    _id: string;
    file_id: string;
    date: string;
    designer1: string;
    designer2: string;
    drawing_name: string;
    drawing_number: string;
    project_name: string;
    scale: string;
    page: number;
  } | null;
}

export interface IraiNodeResponse {
  type_value: string;
  value: any;
  key: any;
  _id: string;
  irai_id: string;
  file_id: string;
  drawing_name: string;
  drawing_number: string;
  page: number;
  type_extract: string;
  nodes: NodeResponse[];
}

export type NewIraiRequest = {
  name_irai: string;
};

export type Node = {
  _id: string;
  graph_id?: string;
  bbox: Record<string, any>;
  polygon?: number[][];  
  key: string;
  parent_id?: string;
  display_name?: string;
};
export type StringNode = Node & {
  value: string;
  type_value: "str";
};
export type IntNode = Node & {
  value: number;
  type_value: "int";
};
export type ListNode = Node & {
  value: string[];
  type_value: "list";
};
export type BooleanNode = Node & {
  value: 0 | 1;
  type_value: "bool";
};
export type DictNode = Node & {
  value: string;
  type_value: "dict";
};
export type RoomNode = Node & {
  value: string;
  type_value: string;
};
export type NodeResponse =
  | StringNode
  | IntNode
  | ListNode
  | BooleanNode
  | DictNode
  | RoomNode;

class IraiController {
  public Get = {
    getIraiById: (irai_id: string, options?: RequestOptions) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.get(`${iraiUrl}/${irai_id}`, options);
    },
    getAllIrai: (
      filters: {
        project_id?: string;
        page?: number;
        page_size?: number;
        type?: string;
        from_date?: string;
        to_date?: string;
        status_type?: string;
      },
      options?: RequestOptions
    ) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      const searchParams = Object.fromEntries(
        Object.entries(filters)
          .filter(([_, v]) => v !== undefined && v !== null && v !== "")
          .map(([k, v]) => [k, String(v)])
      );

      return HttpClient.get(`${iraiUrl}`, {
        ...options,
        search: searchParams,
      });
    },

    getFilesByIraiId: (irai_id: string, options?: RequestOptions) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.get(`${iraiUrl}${irai_id}/files`, options);
    },
    getNodesByIraiId: (irai_id: string, options?: RequestOptions) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.get(`${iraiUrl}/${irai_id}/nodes`, options);
    },
    getTaskByIraiId: (
      irai_id: string,
      status: string,
      options?: RequestOptions
    ) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.get(`${iraiUrl}${irai_id}/${status}`, options);
    },
    getProgressingByIraiId: (irai_id: string, options?: RequestOptions) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.get(`${iraiUrl}${irai_id}/task`, options);
    },
    getDataByObjectId: (irai_id: string, options?: RequestOptions) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.get(`${iraiUrl}${irai_id}/nodes`, options);
    },
  };
  public Post = {
    createNewIrai: (data?: any, options?: RequestOptions) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.post(`${iraiUrl}create-irai`, data, options);
    },
  };
  public Delete = {
    deleteIraiById: (irai_id: string, options?: RequestOptions) => {
      const iraiUrl = FolderService.getHost(FolderService.ApiHost) + "/irai/";
      return HttpClient.delete(`${iraiUrl}${irai_id}`, options);
    },
  };
}

export const IraiService = new IraiController();
